import React, { useState } from 'react';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';

const ExchangeRateTab= () => {
const [showAdd, setShowAdd] = useState(false);
const handleCloseAdd = () => setShowAdd(false);
const handleShowAdd = () => setShowAdd(true);

const [showEdit, setShowEdit] = useState(false);
const handleCloseEdit = () => setShowEdit(false);
const handleShowEdit = () => setShowEdit(true);

return (
<>
    <div className="row border-bottom-2 pb-3">
        <div className="col-md-12">
            <div className="card px-3 py-2">
            <div className="row">
                    <table className="table" style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}
                                ></th>
                                <th colSpan="2" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>
                                    Revenue</th>
                                <th colSpan="2" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderTop: 'none' }}>
                                    Cost</th>
                               
                            </tr>

                            <tr>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Currency</th>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Ex Rate</th>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Agent Ex. Rate</th>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Ex Rate</th>
                                <th style={{ border: '1px solid rgba(0, 0, 0, 0.1)' }}>Agent Ex. Rate</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                           <tr>
                        
                           </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
  

    {showAdd &&
    <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} />}
    {showEdit &&
    <EditCharge showEdit={showEdit} handleCloseEdit={handleCloseEdit} />}
</>
);
};

export default ExchangeRateTab;